const DirectionIntegrated = ({language , token}) => {
    const newDirectionIframe = "https:" +
    window.process.env.URL_Direction
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_direction_display"
        src={newDirectionIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default DirectionIntegrated